import { styled as styledMui, Box } from "@mui/material";

export const WizardContainer = styledMui(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  paddingTop: "12px",
  paddingBottom: "12px",
});

export const WizardHeaderRow = styledMui(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "16px",
  flexWrap: "wrap",
});

export const WizardTitleBlock = styledMui(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  minWidth: 0,
});

export const WizardStepperRow = styledMui(Box)({
  width: "100%",
});

export const WizardContent = styledMui(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  "& .MuiOutlinedInput-root": { borderRadius: "8px" },
  "& .MuiOutlinedInput-notchedOutline": { borderRadius: "8px" },
});

export const WizardReadOnlyAreaRoot = styledMui(Box)({
  "& button, & [role='button'], & a[href]": { cursor: "default" },
  "& .MuiAccordionSummary-root, & [role='tab']": { cursor: "pointer" },
});

export const WizardFooterRow = styledMui(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "12px",
  marginTop: "16px",
});
